<template>
  <div>
    <v-data-table :headers="headers" :items="items" dense hide-default-footer disable-pagination>
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="2">
              <v-select
                outlined
                flat
                dense
                background-color="white"
                v-model.number="year"
                :items="listYear"
                :rules="[v => !!v || 'Year is required']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="2">
              <v-btn color="primary" @click="search">
                <v-icon>
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.month="{ item }">
        {{ listMonth.find(x => x.value === item.month).text }}
      </template>
      <template v-slot:item.amount="{ item }">
        {{ formatPrice(item.amount) }}
      </template>
      <template v-slot:item.otherAmount="{ item }">
        {{ formatPrice(item.otherAmount) }}
      </template>
      <template v-slot:item.difference="{ item }">
        {{ formatPrice(item.otherAmount - item.amount) }}
      </template>
      <template v-slot:item.percentage="{ item }">
        {{ calculatePercentage(item) }}
      </template>
      <template v-slot:body.append="{}">
        <tr>
          <td>Total Sales</td>
          <td class="text-right">{{ formatPrice(totalSalesYear) }}</td>
          <td class="text-right">{{ formatPrice(totalSalesYearMinusOne) }}</td>
          <td class="text-right">{{ formatPrice(totalSalesDifference) }}</td>
          <td class="text-center">
            {{
              calculatePercentage({ otherAmount: totalSalesYearMinusOne, amount: totalSalesYear })
            }}
          </td>
        </tr>
        <tr>
          <td>Rata - rate Per Bulan</td>
          <td class="text-right">{{ formatPrice(totalSalesYear / 12) }}</td>
          <td class="text-right">{{ formatPrice(totalSalesYearMinusOne / 12) }}</td>
          <td class="text-right">{{ formatPrice(totalSalesDifference / 12) }}</td>
          <td class="text-center">
            {{
              calculatePercentage({
                otherAmount: totalSalesYearMinusOne / 12,
                amount: totalSalesYear / 12,
              })
            }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "revenue-yearly",
  data: () => ({
    year: new Date().getFullYear(),
    headers: [],
    items: [],
    listMonth: [
      {
        text: "Januari",
        value: 1,
      },
      {
        text: "Februari",
        value: 2,
      },
      {
        text: "Maret",
        value: 3,
      },
      {
        text: "April",
        value: 4,
      },
      {
        text: "Mei",
        value: 5,
      },
      {
        text: "Juni",
        value: 6,
      },
      {
        text: "Juli",
        value: 7,
      },
      {
        text: "Agustus",
        value: 8,
      },
      {
        text: "September",
        value: 9,
      },
      {
        text: "Oktober",
        value: 10,
      },
      {
        text: "November",
        value: 11,
      },
      {
        text: "Desember",
        value: 12,
      },
    ],
  }),
  computed: {
    ...mapState("incomeStatement", ["listType"]),
    listYear() {
      const year = new Date().getFullYear();
      let array = [];
      for (let i = 0; i <= 5; i++) {
        array.push(year + i);
      }
      for (let i = 1; i <= 5; i++) {
        array.unshift(year - i);
      }
      return array;
    },
    totalSalesYear() {
      let total = 0;
      this.items.forEach(x => {
        total += x.amount;
      });
      return total;
    },
    totalSalesYearMinusOne() {
      let total = 0;
      this.items.forEach(x => {
        total += x.otherAmount;
      });
      return total;
    },
    totalSalesDifference() {
      let total = 0;
      this.items.forEach(x => {
        total += x.otherAmount - x.amount;
      });
      return total;
    },
  },
  created() {
    this.getInitialData();
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    calculatePercentage(item) {
      let difference = item.otherAmount - item.amount;
      if (item.otherAmount > 0) {
        return ((difference / item.otherAmount) * 100).toFixed(2);
      }
      return 0;
    },
    setHeader() {
      this.headers = [
        {
          id: 3,
          text: "Month",
          value: "month",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: this.year,
          value: "amount",
          sortable: false,
          align: "right",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: this.year - 1,
          value: "otherAmount",
          sortable: false,
          align: "right",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: `${this.year} - ${this.year - 1}`,
          value: "difference",
          sortable: false,
          align: "right",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 5,
          text: "%",
          value: "percentage",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ];
    },
    search() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("report/revenueYearly", this.year)
        .then(response => {
          this.setHeader();
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([this.$store.dispatch("incomeStatement/getType")])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style></style>
